export default {
	speak(value) {
		//判断是否存在正在播放的音频
		if (speechSynthesis.speaking) {
			//终止播放
			speechSynthesis.cancel();
		}
		var ssu = new SpeechSynthesisUtterance(value)
		ssu.volume = 1; // 音量0-1
		ssu.rate = 1; // 语速0.1-10
		ssu.pitch = 1; // 音高0-2
		ssu.voiceURI = ''; // 指定希望使用的声音

		// speechSynthesis.speak(new SpeechSynthesisUtterance(value))
		speechSynthesis.speak(ssu)
	},
	pause() {
		speechSynthesis.pause();
	},
	resume() {
		speechSynthesis.resume();
	}
}
